import axios from 'axios';
import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';
import { fetchHandler } from '../../utils/apiUtils';
import { isEmpty } from 'lodash';
import { transformToClientAccessList } from '../../utils/screenPermission';
import {
  dummySampleResult,
  // dummySamplesData,
  dummySampleDetailsData
} from '../../utils/dummyData';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.PortalAPIUrl,
});

const searchSamples = async ({
  locationIdentifier,
  locationFormat,
  sampleNumber,
  maxxID,
  clientID,
  analysisType,
  sampleStatus,
  maxxAlertStatus,
  clientReviewStatus,
  clientIDs,
  reportAddressIDs,
  scenarioIDs,
  attentionName,
  area,
  samplePoint,
  jobNumber,
  matrix,
  projectNumber,
  poNumber,
  receivedDateFrom,
  receivedDateTo,
  sampleDateFrom,
  sampleDateTo,
  sourceSystemIDs,
  divisionIDs,
  page,
  pageSize,
  sortBy,
  functionality,
}) => {
  const queryParams = [];
  console.log(clientIDs, reportAddressIDs, scenarioIDs);
  const clientAccessFilter = transformToClientAccessList(clientIDs, reportAddressIDs, scenarioIDs);
  if (locationIdentifier) {
    queryParams.push(`locationIdentifier=${encodeURIComponent(locationIdentifier.id)}`);
  }
  if (locationFormat && locationFormat.masked && locationFormat.masked.trim() !== '') {
    queryParams.push(`locationFormat=${encodeURIComponent(locationFormat.masked.trim())}`);
    queryParams.push('locationFormatOP=Contains');
  }
  if (sampleNumber && sampleNumber.trim() !== '') {
    queryParams.push(`sampleNumber=${encodeURIComponent(sampleNumber.trim())}`);
    queryParams.push('sampleNumberOP=Contains');
  }
  if (maxxID && maxxID.trim() !== '') {
    queryParams.push(`maxxID=${encodeURIComponent(maxxID.trim())}`);
    queryParams.push('maxxIDOP=Contains');
  }
  if (clientID && clientID.trim() !== '') {
    queryParams.push(`clientID=${encodeURIComponent(clientID.trim())}`);
    queryParams.push('clientIDOP=Contains');
  }
  if (analysisType) {
    queryParams.push(`analysisTypeId=${encodeURIComponent(analysisType.id)}`);
  }
  if (sampleStatus) {
    queryParams.push(`sampleStatusId=${encodeURIComponent(sampleStatus.id)}`);
  }
  if (maxxAlertStatus) {
    queryParams.push(`maxxAlertStatusId=${encodeURIComponent(maxxAlertStatus.id)}`);
  }
  if (clientReviewStatus) {
    queryParams.push(`clientReviewStatusId=${encodeURIComponent(clientReviewStatus.id)}`);
  }

  if (attentionName && attentionName.trim() !== '') {
    queryParams.push(`attentionName=${encodeURIComponent(attentionName.trim())}`);
    queryParams.push('attentionNameOP=Contains');
  }
  if (area && area.trim() !== '') {
    queryParams.push(`area=${encodeURIComponent(area.trim())}`);
    queryParams.push('areaOP=Contains');
  }
  if (samplePoint && samplePoint.trim() !== '') {
    queryParams.push(`samplePoint=${encodeURIComponent(samplePoint.trim())}`);
    queryParams.push('samplePointOP=Contains');
  }
  if (jobNumber && jobNumber.trim() !== '') {
    queryParams.push(`jobNumber=${encodeURIComponent(jobNumber.trim())}`);
    queryParams.push('jobNumberOP=Contains');
  }
  if (Array.isArray(matrix) && matrix.length > 0) {
    const ids = matrix.map((m) => m.id).join(',');
    queryParams.push(`matrixIds=${ids}`);
  }
  if (projectNumber && projectNumber.trim() !== '') {
    queryParams.push(`projectNumber=${encodeURIComponent(projectNumber.trim())}`);
    queryParams.push('projectNumberOP=Contains');
  }
  if (poNumber && poNumber.trim() !== '') {
    queryParams.push(`poNumber=${encodeURIComponent(poNumber.trim())}`);
    queryParams.push('poNumberOP=Contains');
  }

  if (receivedDateFrom) {
    queryParams.push(
      `receivedDateFrom=${encodeURIComponent(receivedDateFrom)}`
    );
  }

  if (receivedDateTo) {
    queryParams.push(
      `receivedDateTo=${encodeURIComponent(receivedDateTo)}`
    );
  }
  if (sampleDateFrom) {
    queryParams.push(
      `sampleDateFrom=${encodeURIComponent(sampleDateFrom)}`
    );
  }

  if (sampleDateTo) {
    queryParams.push(`sampleDateTo=${encodeURIComponent(sampleDateTo)}`);
  }

  if (Array.isArray(sourceSystemIDs) && sourceSystemIDs.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIDs.join(',')}`);
  }

  if (Array.isArray(divisionIDs) && divisionIDs.length > 0) {
    queryParams.push(`divisionIds=${divisionIDs.join(',')}`);
  }
  if (functionality) {
    queryParams.push(`functionality=${encodeURIComponent(functionality)}`);
  }
  if (clientAccessFilter) {
    if (!isEmpty(clientAccessFilter?.ClientAccessList)) {
      queryParams.push(`clientAccessFilter=${encodeURIComponent(JSON.stringify(clientAccessFilter))}`);
    }
  }
  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }
  // console.log('Query params: ', queryParams);
  try {
    const response = await axiosInstance.get(
      `/sample/all/petrohub?${queryParams.join('&')}`
    );

    return response.data.Data.length > 0 ? response.data : { Data: dummySampleResult.data.samples };
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const getSampleBySampleId = async ({
  sampleId,
  assignedDivisions }) => {
  const queryParams = [];
  if (Array.isArray(assignedDivisions) && assignedDivisions.length > 0) {
    queryParams.push(`divisionIds=${assignedDivisions.join(',')}`);
  }
  try {
    const response = await axiosInstance.get(`/sample/samples/id/${sampleId}/Petrohub?${queryParams.join('&')}`);

    return response.data ? response.data : dummySampleDetailsData;
    // return dummySampleDetailsData;
  } catch (e) {
    throw new Error('Error getSampleBySampleId');
  }
};

const getManyResultsBySampleId = async (sampleId) => {
  try {
    const response = await axiosInstance.get(
      `/sample/results/sampleId/${sampleId}/withSpec`
    );

    // console.log("Search job result");
    // console.log(response);
    return response.data; // List of ResultDTO
  } catch (e) {
    throw new Error('Error getManyResultsBySampleId');
  }
};

const searchSampleAlerts = async ({
  locationIDs,
  clientIDs,
  sourceSystemIDs,
  projects,
  page,
  pageSize,
  sortBy,
}) => {
  const queryParams = [];

  if (Array.isArray(locationIDs) && locationIDs.length > 0) {
    const ids = locationIDs.join(',');
    queryParams.push(`locationIds=${ids}`);
  }

  if (Array.isArray(clientIDs) && clientIDs.length > 0) {
    const ids = clientIDs.join(',');
    queryParams.push(`clientIds=${ids}`);
  }

  if (Array.isArray(sourceSystemIDs) && sourceSystemIDs.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIDs.join(',')}`);
  }

  if (Array.isArray(projects) && projects.length > 0) {
    queryParams.push(
      `projects=${projects.map((x) => encodeURIComponent(x)).join(',')}`
    );
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.get(
      `/sample/SampleAlerts?${queryParams.join('&')}`
    );

    // console.log("Search job result");
    // console.log(response);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const createCarRequest = async ({ sampleId }) => {
  try {
    const response = await axiosInstance.post('/sample/CreateCarRequest', {
      SampleID: sampleId,
    });

    return response.data;
  } catch (e) {
    throw new Error('Error createCarRequest');
  }
};

const getTestReportingGroups = async ({ sampleId }) => {
  const queryParams = [];

  if (sampleId) {
    queryParams.push(`sampleIdText=${sampleId}`);
  }
  try {
    const response = await axiosInstance.post(
      `Sample/GetTestReportingGroups?${queryParams.join('&')}`
    );
    // console.log(response.data);
    return response.data;
  } catch (e) {
    throw new Error('Error GetTestReportingGroups');
  }
};

const getRecentSamples = async (
  {
    sampleStatusName,
    locationIDs,
    clientIDs,
    sourceSystemIDs,
    divisionIDs,
    projects,
    pageSize,
    sortBy,
  },
  abortController
) => {
  const queryParams = [];

  if (sampleStatusName && sampleStatusName.trim() !== '') {
    queryParams.push(
      `sampleStatusName=${encodeURIComponent(sampleStatusName.trim())}`
    );
  }

  if (Array.isArray(locationIDs) && locationIDs.length > 0) {
    const ids = locationIDs.join(',');
    queryParams.push(`locationIds=${ids}`);
  }

  if (Array.isArray(clientIDs) && clientIDs.length > 0) {
    const ids = clientIDs.join(',');
    queryParams.push(`clientIds=${ids}`);
  }

  if (Array.isArray(sourceSystemIDs) && sourceSystemIDs.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIDs.join(',')}`);
  }

  if (Array.isArray(projects) && projects.length > 0) {
    queryParams.push(
      `projects=${projects.map((x) => encodeURIComponent(x)).join(',')}`
    );
  }

  if (Array.isArray(divisionIDs) && divisionIDs.length > 0) {
    queryParams.push(`divisionIds=${divisionIDs.join(',')}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.post(
      `/sample/RecentSamples?${queryParams.join('&')}`,
      null,
      {
        signal: abortController?.signal,
      }
    );

    // console.log("Search job result");
    // console.log(response);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      console.log(e);
      throw e;
    }
  }

  return [];
};

const getRecentSamplesVF = async (
  {
    sampleStatusName,
    locationIDs,
    clientIDs,
    sourceSystemIDs,
    divisionIDs,
    projects,
    pageSize,
    page,
    sortBy,
  },
  abortController
) => {
  const queryParams = [];

  if (sampleStatusName && sampleStatusName.trim() !== '') {
    queryParams.push(
      `SampleStatusName=${encodeURIComponent(sampleStatusName.trim())}`
    );
  }

  if (Array.isArray(locationIDs) && locationIDs.length > 0) {
    const ids = locationIDs.join(',');
    queryParams.push(`locationIds=${ids}`);
  }

  if (Array.isArray(clientIDs) && clientIDs.length > 0) {
    const ids = clientIDs.join(',');
    queryParams.push(`clientIds=${ids}`);
  }

  if (Array.isArray(sourceSystemIDs) && sourceSystemIDs.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIDs.join(',')}`);
  }

  if (Array.isArray(projects) && projects.length > 0) {
    queryParams.push(
      `projects=${projects.map((x) => encodeURIComponent(x)).join(',')}`
    );
  }

  if (Array.isArray(divisionIDs) && divisionIDs.length > 0) {
    queryParams.push(`divisionIds=${divisionIDs.join(',')}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.post(
      `Stats/sample/count/all?${queryParams.join('&')}`,
      null,
      {
        signal: abortController?.signal,
      }
    );

    // console.log("Search job result");
    // console.log(response);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      console.log(e);
      throw e;
    }
  }

  return [];
};

const getSampleResultHistory = async ({ assetPartId, locationId }, abortController) => {
  const queryParams = [];

  if (assetPartId) {
    queryParams.push(`assetPartId=${encodeURIComponent(assetPartId)}`);
  }

  if (locationId) {
    queryParams.push(`locationId=${locationId}`);
  }

  try {
    const response = await axiosInstance.post(
      `/Sample/GetSampleResultHistory?${queryParams.join('&')}`, {}, {
        signal: abortController?.signal
      }
    );
    return response.data;
  } catch (e) {
    if (axios.isCancel(e)) {
      console.log('Cancel request getSampleResultHistory');
      return {};
    }
    throw e;
  }
};

const getLabTurnaroundTime = async ({
  clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds,
}, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/DaysOut', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getRushTurnaroundTime = async ({
  clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds,
}, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/DaysOut', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getRegularTurnaroundTime = async ({
  clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds,
}, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/DaysOut', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getSampleSubmittedOP = async ({
  clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds,
}, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/DaysOut', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);
const getSampleReportedOP = async ({
  clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds,
}, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/DaysOut', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getSampleContainerTypesReceived = async ({ clientIds,
  divisionIds,
  locationIds,
  clientAccessList,
  scenarioIds,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/CylinderByState', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getSamplesBySubmissionTypeOP = async ({ clientIds,
  divisionIds,
  locationIds,
  clientAccessList,
  scenarioIds,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/CylinderByState', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getSampleStatusOP = async ({ clientIds,
  divisionIds,
  locationIds,
  clientAccessList,
  scenarioIds,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/CylinderByState', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const acceptRejectSample = async ({ sampleId, action }, abortController) => {
  fetchHandler(axiosInstance, '/sample/ClientReview', {
    SampleID: sampleId,
    Action: action,
  }, abortController);
};

const PetrohubSampleApi = {
  acceptRejectSample,
  searchSamples,
  getSampleBySampleId,
  getManyResultsBySampleId,
  searchSampleAlerts,
  createCarRequest,
  getRecentSamples,
  getRecentSamplesVF,
  getTestReportingGroups,
  getSampleResultHistory,
  getLabTurnaroundTime,
  getRushTurnaroundTime,
  getRegularTurnaroundTime,
  getSampleSubmittedOP,
  getSampleReportedOP,
  getSampleContainerTypesReceived,
  getSamplesBySubmissionTypeOP,
  getSampleStatusOP,
};

export default PetrohubSampleApi;
